import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import {
    VerificationTransactionsResponse
} from "@idw-types/data/reports/verification-transactions-response";

export const getVerificationTransactionsRequest = async (
    queryParameters: Array<QueryParameter>, signal: AbortSignal
): Promise<{ data: VerificationTransactionsResponse, error: any }> => {
    const route = apiRoutes.reports.verificationTransactions.results;

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters, signal);
    return { data, error };
};